export const ASIDE_WIDTH = '26.25em';
